import { render, staticRenderFns } from "./PaymentSuccessStretchGoals.vue?vue&type=template&id=cfca0bba"
import script from "./PaymentSuccessStretchGoals.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessStretchGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports